function DocumentSlider( $ ) {

  const $slider = $('#document-slider');

  /**
	* initialization method, set up slick slider
	*/
  function init() {

    if($slider) {

      const slides = document.querySelectorAll('.documents__slider-slide');

      // Set slide width on mobile devices
      if(window.innerWidth < 768) {
        let calculatedWidth = (window.innerWidth * 53 / 100); 
        slides.forEach( slide => {
          slide.style.width = `${calculatedWidth}px`;
        });
      }

      // Slick setup
      $slider.slick({
        speed: 500,
        slidesToShow: 4,
        prevArrow:"<div class='slick-prev-arrow'></div>",
        nextArrow:"<div class='slick-next-arrow'></div>",
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              variableWidth: true
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      });
      
    }
  }

  return {
    init
  }
}

export default DocumentSlider;


